import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import { LinkContext } from "../../LinkProvider";

import imgLeft from "../../img/AboutUs/rec5.webp";
import imgCenter from "../../img/AboutUs/rec6.webp";
import Fade from 'react-reveal/Fade';

function EducationLight() {
  const { link } = useContext(LinkContext);
  const { t } = useTranslation();

  return (
    <section className="mt-[80px] xl:mt-[160px]">
      {/* Desktop */}
      <div className="hidden xl:block">
        <div className="relative mx-auto h-[484px] max-w-[1220px]">
          {/* Left image */}
          <Fade bottom>
          <div className="absolute left-0 top-[53px] h-[332px] w-[279px] overflow-hidden">
            <img src={imgLeft} alt="" className="h-full w-full object-cover" />
          </div>
          </Fade>
          {/* Center image */}
          <Fade bottom delay={100}>
          <div className="absolute left-[324px] top-0 h-[484px] w-[478px] overflow-hidden">
            <img src={imgCenter} alt="" className="h-full w-full object-cover" />
          </div>
          </Fade>
          {/* Right text */}
          <Fade bottom delay={200}>
          <div className="absolute left-[837px] top-0 flex w-[383px] flex-col gap-[20px]">
            <h2 className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] text-[#3273b4]">
              {t("about.education.title")}
            </h2>
            <span className="block h-[4px] w-[104px] bg-[#05193a]" />
            <div className="flex flex-col gap-[15px]">
              <p className="font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
                {t("about.education.text1")}
              </p>
              <p className="font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
                {t("about.education.text2")}
              </p>
            </div>
            <a
              href={link}
              className="inline-flex h-[42px] w-fit items-center justify-center rounded-[10px] bg-[#05193a] px-[35px] font-[Inter] text-[16px] font-light capitalize text-white transition-colors hover:bg-[#0d2c60]"
            >
              {t("header.openAccount")}
            </a>
          </div>
          </Fade>
        </div>
      </div>

      {/* Mobile */}
      <Fade bottom>
      <div className="xl:hidden px-[20px]">
        <div className="flex flex-col gap-[15px]">
          <h2 className="font-['Nunito_Sans'] text-[26px] font-black leading-[1.5] text-[#3273b4]">
            {t("about.education.title")}
          </h2>
          <span className="block h-[4px] w-[104px] bg-[#05193a]" />
          <p className="font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193a]">
            {t("about.education.text1")}
          </p>
          <p className="font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193a]">
            {t("about.education.text2")}
          </p>
        </div>
        <a
          href={link}
          className="mt-[30px] inline-flex h-[38px] items-center justify-center rounded-[10px] bg-[#05193a] px-[28px] font-[Inter] text-[14px] font-light capitalize text-white transition-colors hover:bg-[#0d2c60]"
        >
          {t("header.openAccount")}
        </a>
      </div>
      </Fade>
    </section>
  );
}

export default EducationLight;
